/**
 * Wrapper to handle data loaded from redirect media (including the legacy redirect cookie).
 *
 * @module
 */

var _ = require('optimizely-client-fn');
var di = require('../di');

var ObservedRedirectStore = di.get('stores/observed_redirect');

/**
 * Check both old- and new-style redirect referrers, whether or not the current Snippet is opted into the new redirect
 * system for its own initiated redirects. This allows us to chain the original referrers through old and new redirects,
 * and allows us to continue to fix the referrer in old-style tracker plugins, even though they can't perform
 * post-redirect decision tracking.
 *
 * @returns {string|null}
 */
exports.getReferrer = function(): string|null {
  var redirectData = ObservedRedirectStore.get();
  if (redirectData) {
    return redirectData.referrer;
  }

  return null;
};

/**
 * @typedef {Object} RedirectExperimentAndVariation
 * @property {string} [experimentId] In practice, this should never be
 * @property {string} variationId
 */

/**
 * @returns {module:api_events/index~RedirectExperimentAndVariationIds|null} The IDs of the experience that redirected to this page, if any.
 */
exports.getExperimentAndVariation = function(): any|null {
  var redirectData = ObservedRedirectStore.get();
  if (redirectData && _.isString(redirectData.variationId)) {
    return _.pick(redirectData, ['experimentId', 'variationId']);
  }

  return null;
};
